<template>
    <div>
        <el-dialog
                :title="title"
                :visible="showSerial"
                :close-on-click-modal="!showSerial"
                :before-close="close"
                width="600px"
        >
            <div class="Field">
                <el-form ref="form" :model="SerialModel" label-width="120px" :rules="rules">
                    <el-form-item label="领域名称" prop="productDomainId">
                        <el-select v-model="SerialModel.productDomainId" placeholder="请选择" filterable style="width:410px" @change="getdropList(1,SerialModel.productDomainId)">
                            <el-option v-for="item in fieldLevel" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属一级产品" prop="firstProductId">
                        <el-select  v-model="SerialModel.firstProductId" placeholder="请选择" filterable style="width:410px"  @change="getdropList(2,SerialModel.firstProductId)">
                            <el-option v-for="item in oneLevel" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属二级产品" prop="secondProductId">
                        <el-select  v-model="SerialModel.secondProductId" filterable placeholder="请选择" style="width:410px"  @change="getdropList(3,SerialModel.secondProductId)">
                            <el-option v-for="item in twoLevel" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属三级产品" prop="secondProductId" >
                        <el-select  v-model="SerialModel.thirdProductId" filterable placeholder="请选择" style="width:410px">
                            <el-option v-for="item in threeLevel" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="所属品牌" prop="brandId" >
                        <el-select  v-model="SerialModel.brandId" filterable placeholder="请选择" style="width:410px">
                            <el-option v-for="item in brandList" :key="item.id" :label="item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="系列名称" prop="serialName" class="m-t-20">
                        <el-input type="text" v-model.trim="SerialModel.serialName" maxlength="100" placeholder="请输入系列名称，不超过100字" class="edit_input" style="width: 410px"></el-input>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer" style="text-align: center;margin-top: 50px;" slot="footer">
                    <el-button type="primary" @click="push('form')">确认</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import { getproSelect,getbrandselect,addserial,editserial } from "@/service/dataFrame";
    import { getStorageUserRoleId } from '@/utils/store'
    export default {
        name: "addSerial",
        props: {
            // title: {
            //     type: String,
            //     default: "新增产品系列",
            // },
            currentParam:{
                type:Object,
                default(){return {}}
            }
        },
        data(){
            return{
                showSerial:true,
                title: '新增产品系列',
                SerialModel:{
                    productDomainId:'',
                    firstProductId:'',
                    secondProductId:'',
                    thirdProductId:'',
                    brandId:'',
                    serialName:''
                },
                fieldLevel:[],
                oneLevel:[],
                twoLevel:[],
                threeLevel:[],
                brandList:[],
                rules:{
                    productDomainId: [{required:true, message: '请选择领域名称！', trigger: 'change'}],
                    firstProductId: [{required:true, message: '请选择所属一级产品！', trigger: 'change'}],
                    secondProductId: [{required:true, message: '请选择所属二级产品！', trigger: 'change'}],
                    thirdProductId: [{required:true, message: '请选择所属三级产品！', trigger: 'change'}],
                    brandId: [{required:true, message: '请选择所属品牌！', trigger: 'change'}],
                    serialName: [{required:true, message: '请输入系列名称！', trigger: 'blur'}],
                }
            }
        },
        methods:{
            close(){
                this.$emit("close")
            },
            push(){
                this.$refs['form'].validate((valid) => {
                    if(valid){
                        // editserial
                        if(this.currentParam.update == -1) {
                            let param={
                                productDomainId:this.SerialModel.productDomainId,
                                firstProductId:this.SerialModel.firstProductId,
                                secondProductId:this.SerialModel.secondProductId,
                                thirdProductId:this.SerialModel.thirdProductId,
                                brandId:this.SerialModel.brandId,
                                serialName:this.SerialModel.serialName,
                                userId:getStorageUserRoleId()
                            }
                            addserial(param).then((res)=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.$emit("close")
                                this.$message.success("新增成功")
                                this.$emit("refreshList")
                            })
                        }else {
                            let param={
                                productDomainId:this.SerialModel.productDomainId,
                                firstProductId:this.SerialModel.firstProductId,
                                secondProductId:this.SerialModel.secondProductId,
                                thirdProductId:this.SerialModel.thirdProductId,
                                brandId:this.SerialModel.brandId,
                                serialName:this.SerialModel.serialName,
                                userId:getStorageUserRoleId(),
                                id: this.currentParam.id
                            }
                            editserial(param).then(res=>{
                                if(res.Result != 1) {
                                    return this.$message.error(res.Message)
                                }
                                this.$emit("close")
                                this.$message.success("修改成功")
                                this.$emit("refreshList")
                            })
                        }
                    }
                })
            },
            getBrList(){
                getbrandselect().then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    this.brandList=res.Data;
                })
            },
            getdropList(data,updata){
                let param={
                    levelType:data
                }
                if(data>0){
                    param.superiorId=updata
                }
                getproSelect(param).then((res)=>{
                    if(res.Result != 1) {
                        return this.$message.error(res.Message)
                    }
                    if(data==0){
                        this.fieldLevel=res.Data;
                    }
                    if(data==1){
                        this.oneLevel=res.Data;
                        if(this.currentParam.update == -1) {
                            this.SerialModel.firstProductId='';
                            this.SerialModel.secondProductId='';
                            this.SerialModel.thirdProductId='';
                            this.twoLevel=[];
                            this.threeLevel=[];
                        }
                    }
                    if(data==2){
                        this.twoLevel=res.Data;
                        if(this.currentParam.update == -1) {
                            this.SerialModel.secondProductId='';
                            this.SerialModel.thirdProductId='';
                            this.threeLevel=[];
                        }
                    }
                    if(data==3){
                        this.threeLevel=res.Data;
                        if(this.currentParam.update == -1) {
                            this.SerialModel.thirdProductId='';
                        }
                    }
                })
            },
        },
        mounted() {
            
            if(this.currentParam){
                const param = JSON.parse(JSON.stringify(this.currentParam));
                if(param.update == 1) {
                    this.title = '修改产品系列'
                    this.getBrList();
                    if(!param.domainId) {
                        this.getdropList(0,0);
                        this.$nextTick(()=> {
                            this.SerialModel = {
                                brandId: Number(param.brandId),
                                serialName: param.serialName
                            }
                            setTimeout(()=>{
                                this.$refs.form.clearValidate();
                            },30)
                        })
                        return
                    }
                    this.getdropList(0,0);
                    this.getdropList(1,param.domainId);
                    this.getdropList(2,param.firstProductId);
                    this.getdropList(3,param.secondProductId);
                    this.$nextTick(()=> {
                        this.SerialModel = {
                            productDomainId: Number(param.domainId),
                            firstProductId: Number(param.firstProductId),
                            secondProductId: Number(param.secondProductId),
                            thirdProductId: Number(param.thirdProductId),
                            brandId: Number(param.brandId),
                            serialName: param.serialName
                        }
                    })
                }else{
                    this.getdropList(0,0);
                    this.getBrList();
                }
                    
           }
        }
    }
</script>

<style lang="scss">
     .m-t-20{
         margin-top: 20px;
     }
</style>
